/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	WhatsAppAiAgentConfigConsentStatusPathParams,
	WhatsAppAiAgentConfigConsentStatusResponse,
} from '../types/WhatsAppAiAgentConfigConsentStatus'

/**
 * GET /organisations/:organisationId/whatsapp-ai-consent
 * @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiAgentConfigController.php WhatsAppAiAgentConfigController::consentStatus
 */
export async function whatsAppAiAgentConfigConsentStatus(
	organisationId: WhatsAppAiAgentConfigConsentStatusPathParams['organisationId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<WhatsAppAiAgentConfigConsentStatusResponse>> {
	return axiosInstance.get(`/organisations/${organisationId}/whatsapp-ai-consent`, config)
}
